import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the CargandoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-cargando',
  templateUrl: 'cargando.html',
})
export class CargandoPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

}



// WEBPACK FOOTER //
// ./src/pages/cargando/cargando.ts